import { render, staticRenderFns } from "./PrecioNormal.vue?vue&type=template&id=589376f2&scoped=true&"
import script from "./PrecioNormal.vue?vue&type=script&lang=js&"
export * from "./PrecioNormal.vue?vue&type=script&lang=js&"
import style0 from "./PrecioNormal.vue?vue&type=style&index=0&id=589376f2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "589376f2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardText } from 'vuetify/lib/components/VCard';
installComponents(component, {VCardText})
